import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ApprovalWrapper } from './ApprovalStyled'; // Import the styled component

const Discounts = ({ quoteDiscount, bundleDiscount }) => {
    
    return (
        <ApprovalWrapper>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }}
                    aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Type</TableCell>
                            <TableCell>Value(%)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>                        
                            <TableRow>
                                <TableCell component="th" scope="row">
                                Quote Discount
                                </TableCell>
                                <TableCell>                                    
                                {quoteDiscount + "%"}
                                </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                Bundle Discount
                            </TableCell>
                            <TableCell>
                                {bundleDiscount ? bundleDiscount + "%" : "-"}
                            </TableCell>
                        </TableRow>
                       
                    </TableBody>
                </Table>
            </TableContainer>
        </ApprovalWrapper>
    );
}

export default Discounts;
